module.exports = __webpack_public_path__ + "static/clearmatics-research-red-logo-b013b8203cd379a4925c7b9a84ee2773.svg";